import Notify from "./notifyActions";

export const REPORT_LIST = "REPORT_LIST";
export const reportList = pager => ({
  type: REPORT_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: "reportlist",
      method: "Post",
      data: pager
    }
  }
});

export const REPORT_DOWNLOAD = "REPORT_DOWNLOAD";
export const reportDownload = data => {
  return (dispatch, getState) => {
    dispatch({
      type: REPORT_DOWNLOAD,
      payload: {
        request: {
          mode: "no-cors",
          url: "reportdownload/" + data.id,
          method: "GET"
        }
      }
    }).then(resp => {
      if (resp.payload.data) {
        window.open(resp.payload.data);
      }
    });
  };
};

export const SEND_EMAIL_REPORT = "SEND_EMAIL_REPORT";
export const SEND_EMAIL_REPORT_SUCCESSFULL_TOAST =
  "send_email_report_successfull_taost";
export const SEND_EMAIL_REPORT_UNSUCCESSFULL_TOAST =
  "send_email_report_unsuccessfull_taost";

export const sendEmail = data => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SEND_EMAIL_REPORT,
        payload: {
          request: {
            url: "ReportEmail",
            method: "POST",
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload && response.payload.data) {
          dispatch(Notify.success(SEND_EMAIL_REPORT_SUCCESSFULL_TOAST));
          resolve(response.payload.data);
        } else {
          dispatch(Notify.error(SEND_EMAIL_REPORT_UNSUCCESSFULL_TOAST));
          resolve(response.type);
        }
      });
    });
  };
};

export const REPORT_DELETE = "REPORT_DELETE";
export const REPORT_DELETE_SUCCESSFULL_TOAST =
  "report_delete_successfull_toast";
export const REPORT_DELETE_UNSUCCESSFULL_TOAST =
  "report_delete_unsuccessfull_toast";

export const reportDelete = (reportIds, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: REPORT_DELETE,
        payload: {
          request: {
            url: `Report`,
            method: "DELETE",
            data: { request: { reportids: reportIds } }
          }
        }
      })
        .then(response => {
          if (response.payload && response.payload.data) {
            dispatch(Notify.success(REPORT_DELETE_SUCCESSFULL_TOAST));
            dispatch(reportList(pager));
            resolve(response.payload);
          } else {
            dispatch(Notify.error(REPORT_DELETE_UNSUCCESSFULL_TOAST));
            resolve(response.payload);
          }
        })
        .catch(error => {
          dispatch(Notify.error(error));
          reject(error);
        });
    });
  };
};
